import React, { useContext } from 'react';
import {
  Box,
  Button,
  Modal,
  SpaceBetween,
  TextContent,
} from '@cloudscape-design/components';
import { PermissionAwareButton } from 'src/components/PermissionAwareButton';
import { useManualDeployment } from 'src/hooks/useManualDeployment';
import { OperatorModalContext } from 'src/context/operatorModalContext';

export const PromoteModal = () => {
  const { promoteConfig, setPromoteConfig } = useContext(OperatorModalContext);
  const { deploymentRequestLoading, requestDeployment } = useManualDeployment();

  const onClose = () => {
    setPromoteConfig(null);
  };

  if (!promoteConfig) return <></>;

  return (
    <Modal
      header="Deploy model to Production?"
      visible={!!promoteConfig}
      onDismiss={onClose}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={onClose}>
              Cancel
            </Button>
            <PermissionAwareButton
              loading={deploymentRequestLoading}
              variant="primary"
              requiredPermission="ADMINISTER"
              actionDescription="promote models"
              onClick={() => {
                promoteConfig && requestDeployment(promoteConfig.arn);
                onClose();
              }}
            >
              Request Promotion
            </PermissionAwareButton>
          </SpaceBetween>
        </Box>
      }
    >
      <TextContent>
        <p>
          Using <strong>{promoteConfig.modelName}</strong>, this will create a
          new model in the same account with the same settings, without the
          &apos;beta-&apos; prefix.
        </p>
      </TextContent>
    </Modal>
  );
};
